// IMPORTS

// global
import { Network } from "../globals"

// INTERFACE

export default class LendingPoolInterfaceConfig {
  public appId: number
  public asset1Id: number
  public asset2Id: number
  public lpAssetId: number
  public market1AppId: number
  public market2AppId: number
  public poolAppId: number
  public opFarmAppId: number

  constructor(
    appId: number,
    asset1Id: number,
    asset2Id: number,
    lpAssetId: number,
    market1AppId: number,
    market2AppId: number,
    poolAppId: number,
    opFarmAppId: number
  ) {
    this.appId = appId
    this.asset1Id = asset1Id
    this.asset2Id = asset2Id
    this.lpAssetId = lpAssetId
    this.market1AppId = market1AppId
    this.market2AppId = market2AppId
    this.poolAppId = poolAppId
    this.opFarmAppId = opFarmAppId
  }
}

export const LendingPoolInterfaceConfigs = {
  [Network.MAINNET]: [
    new LendingPoolInterfaceConfig(1037244457, 31566704, 841126810, 841171328, 818182048, 841145020, 841170409, 841189050), // USDC / STBL2
    new LendingPoolInterfaceConfig(1037246265, 1, 841126810, 855717054, 818179346, 841145020, 855716333, 841189050), // ALGO / STBL2
    new LendingPoolInterfaceConfig(1037246753, 386192725, 841126810, 870151164, 818183964, 841145020, 870150391, 841189050), // goBTC / STBL2
    new LendingPoolInterfaceConfig(1037247557, 386195940, 841126810, 870150187, 818188286, 841145020, 870143131, 841189050), // goETH / STBL2
    new LendingPoolInterfaceConfig(1037247962, 841126810, 900652777, 900924035, 841145020, 900883415, 900923609, 841189050), // STBL2 / BANK
    new LendingPoolInterfaceConfig(1037248443, 1, 31566704, 919950894, 818179346, 818182048, 919950071, 841189050), // ALGO / USDC
    new LendingPoolInterfaceConfig(1037248737, 1, 900652777, 962367827, 818179346, 900883415, 962367416, 841189050), // ALGO / BANK
  ],
  [Network.TESTNET]: [
    new LendingPoolInterfaceConfig(1037248737, 1, 900652777, 962367827, 818179346, 900883415, 962367416, 841189050) // bad config
  ],
}

// STRING CONTSTANTS

export const LENDING_POOL_INTERFACE_STRINGS = {
  market1_app_id: "market1_app_id",
  market2_app_id: "market2_app_id",
  lp_market_app_id: "lp_market_app_id",
  lending_manager_app_id: "lending_manager_app_id",
  pool_app_id: "pool_app_id",
  pool_manager_app_id: "pool_manager_app_id",
  op_farm_app_id: "op_farm_app_id",
  asset1_id: "asset1_id",
  asset2_id: "asset2_id",
  b_asset1_id: "b_asset1_id",
  b_asset2_id: "b_asset2_id",
  lp_asset_id: "lp_asset_id",
  
  pool_step_1: "pool_step_1",
  pool_step_2: "pool_step_2",
  pool_step_3: "pool_step_3",

  burn_step_1: "burn_step_1",
  burn_step_2: "burn_step_2",

  swap_step_1: "swap_step_1",
  swap_step_2: "swap_step_2",
  swap_step_3: "swap_step_3",
    
  swap_for_exact: "swap_for_exact",
  swap_exact_for: "swap_exact_for"
}